import { useEffect, useState } from "react"

import { useGoogleMaps } from "./useGoogleMaps"

interface UseCalculateCoordinatesValue {
  coordinates: google.maps.LatLngLiteral | null
}
/**
 * The useCalculateCoordinates service/hook uses google maps
 * api to convert address to coordinates
 *
 * @returns coordinates
 * @example
 * const {
 *   coordinates
 * } = useCalculateCoordinates("address")
 */
export const useCalculateCoordinates = (
  address: string
): UseCalculateCoordinatesValue => {
  const [coordinates, setCoordinates] =
    useState<google.maps.LatLngLiteral | null>(null)
  const { googleMaps, isLoaded } = useGoogleMaps()

  useEffect(() => {
    if (googleMaps && isLoaded) {
      const geocoder = new googleMaps.Geocoder()

      void geocoder.geocode({ address }, (results, status) => {
        const firstResult = results?.[0]

        if (status === googleMaps.GeocoderStatus.OK && firstResult) {
          setCoordinates(firstResult.geometry.location.toJSON())
        }
      })
    }
  }, [address, googleMaps, isLoaded])

  return { coordinates }
}
